export const RESET_STATE = 'RESET_STATE';
export const SET_IS_MOBILE = 'SET_IS_MOBILE';


// WEBPACK FOOTER //
// ./src/store/root-mutations.js